module.exports = __webpack_public_path__ + "static/theNumbers-453cca3067b13bcae421b69c667ad3a2.png";